import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StartComponent } from './start/start.component';
import { MakeAppointmentContactDetailsComponent } from './make-appointment-contact-details/make-appointment-contact-details.component';
import { MakeAppointmentThankYouComponent } from './make-appointment-thank-you/make-appointment-thank-you.component';
import { TellUsComponent } from './tell-us/tell-us.component';
import { OTPComponent } from './otp/otp.component'; 
import { IdentifyYourCompanyComponent } from './identify-your-company/identify-your-company.component';
import { ThankYouComponent } from './thank-you/thank-you.component';
import { CompanyNotFoundComponent } from './company-not-found/company-not-found.component';
import { MultipleCompanyComponent } from './multiple-company/multiple-company.component';
import { ConfirmYourCompanyComponent } from './confirm-your-company/confirm-your-company.component';
import { CompanyDetailsComponent } from './company-details/company-details.component';
import { DirectorDetailsComponent } from './director-details/director-details.component';
import { BusinessDetailComponent } from './business-detail/business-detail.component';
import { AboutYourBusinessComponent } from './about-your-business/about-your-business.component';
import { AboutYourBusinessInfoComponent } from './about-your-business-info/about-your-business-info.component';
import { TaxStatusComponent } from './tax-status/tax-status.component';
import { AboutYourTransactionComponent } from './about-your-transaction/about-your-transaction.component';
import { BusinessBankingServiceComponent } from './business-banking-service/business-banking-service.component';
import { UploadDocumentComponent } from './upload-document/upload-document.component';
import { UploadNRICComponent } from './upload-nric/upload-nric.component';
import { SignatureComponent } from './signature/signature.component';
import { SecondDirectorUploadNricComponent } from './second-director-upload-nric/second-director-upload-nric.component';
import { SecondDirectorSignatureComponent } from './second-director-signature/second-director-signature.component';
import { DeclarationComponent } from './declaration/declaration.component';
import { SecondDirectorDeclarationComponent } from './second-director-declaration/second-director-declaration.component';
import { SecondOTPComponent } from './second-otp/second-otp.component';
import { SecondDirectorDetailsComponent } from './second-director-details/second-director-details.component';
import { CorrectionRequestComponent } from './correction-request/correction-request.component';
import { SalesAssistedThankYouComponent } from './sales-assisted-thank-you/sales-assisted-thank-you.component';
import { CompanyConstitutionComponent } from './company-constitution/company-constitution.component';
import { ThankYouApplicationComponent } from './thank-you-application/thank-you-application.component';
import { ThankYouWithoutEkycComponent } from './thank-you-without-ekyc/thank-you-without-ekyc.component';
import { SecondDirectorThankYouApplicationComponent } from './second-director-thank-you-application/second-director-thank-you-application.component';
import { SecondDirectorCompanyConstitutionComponent } from './second-director-company-constitution/second-director-company-constitution.component';
import { SecondDirectorThankYouWithoutEkycComponent } from './second-director-thank-you-without-ekyc/second-director-thank-you-without-ekyc.component';
import { DirectorConfirmComponent } from './director-confirm/director-confirm.component';
import { SecondDirectorConfirmComponent } from './second-director-confirm/second-director-confirm.component';
import { IdentifyExistComponent } from './identify-exist/identify-exist.component';
import { CompanyDetailsInfoComponent } from './company-details-info/company-details-info.component';
import { InfoUpdateYourRecordComponent } from './info-update-your-record/info-update-your-record.component';
import { LastStepComponent } from './last-step/last-step.component';
import { EndLastStepComponent } from './end-last-step/end-last-step.component';
import { SmileyComponent } from './smiley/smiley.component';
import { RedirectingComponent } from './redirecting/redirecting.component';
import { ThankYouDirectorComponent } from './thank-you-director/thank-you-director.component';
import { OneMoreStepWithoutEkycComponent } from './one-more-step-without-ekyc/one-more-step-without-ekyc.component';
import { PasscodeComponent } from './passcode/passcode.component';


const routes: Routes = [
  //change path'' to test each page
  { path: '', redirectTo: '/start?product=U8&source1=embdigital&source2=web_top', pathMatch: 'full' },
  { path: 'start', component: StartComponent },
  { path: 'make-appointment-contact-details', component: MakeAppointmentContactDetailsComponent },
  { path: 'make-appointment-thank-you', component: MakeAppointmentThankYouComponent },
  { path: 'tell-us', component: TellUsComponent },
  { path: 'otp', component: OTPComponent },
  { path: 'identify-your-company', component: IdentifyYourCompanyComponent },
  { path: 'thank-you', component: ThankYouComponent},
  { path: 'company-details-info', component: CompanyDetailsInfoComponent},
  { path: 'confirm-your-company', component: ConfirmYourCompanyComponent},
  { path: 'multiple-company', component: MultipleCompanyComponent},
  { path: 'company-details', component: CompanyDetailsComponent },
  { path: 'director-details', component: DirectorDetailsComponent },
  { path: 'business-detail', component: BusinessDetailComponent },
  { path: 'about-your-business', component: AboutYourBusinessComponent },
  { path: 'about-your-business-info', component: AboutYourBusinessInfoComponent },
  { path: 'tax-status', component: TaxStatusComponent },
  { path: 'about-your-transaction', component: AboutYourTransactionComponent },
  { path: 'business-banking', component: BusinessBankingServiceComponent },
  { path: 'upload-document', component: UploadDocumentComponent },
  { path: 'upload-nric', component: UploadNRICComponent },
  { path: 'signature', component: SignatureComponent },
  { path: 'second-director-upload-nric', component: SecondDirectorUploadNricComponent },
  { path: 'second-director-signature', component: SecondDirectorSignatureComponent },
  { path: 'declaration', component: DeclarationComponent },
  { path: 'second-director-declaration', component: SecondDirectorDeclarationComponent },
  { path: 'second-otp', component: SecondOTPComponent },
  { path: 'second-director-details', component: SecondDirectorDetailsComponent },
  { path: 'correction-request', component: CorrectionRequestComponent },
  { path: 'sales-assisted-thank-you', component: SalesAssistedThankYouComponent },
  { path: 'company-constitution', component: CompanyConstitutionComponent },
  { path: 'thank-you-application', component: ThankYouApplicationComponent },
  { path: 'thank-you-without-ekyc', component: ThankYouWithoutEkycComponent },
  { path: 'second-director-company-constitution', component: SecondDirectorCompanyConstitutionComponent },
  { path: 'second-director-thank-you-application', component: SecondDirectorThankYouApplicationComponent },
  { path: 'second-director-thank-you-without-ekyc', component: SecondDirectorThankYouWithoutEkycComponent },
  { path: 'director-confirm', component: DirectorConfirmComponent },
  { path: 'second-director-confirm', component: SecondDirectorConfirmComponent },
  { path: 'identify-exist', component: IdentifyExistComponent},
  { path: 'info-update-your-record', component: InfoUpdateYourRecordComponent },
  { path: 'company-not-found', component: CompanyNotFoundComponent },   
  { path: 'last-step', component: LastStepComponent },
  { path: 'end-last-step', component: EndLastStepComponent },
  { path: 'smiley', component: SmileyComponent },
  { path: 'redirecting', component: RedirectingComponent },
  { path: 'thank-you-director', component: ThankYouDirectorComponent },
  { path: 'one-more-step-without-ekyc', component: OneMoreStepWithoutEkycComponent },
  { path: 'passcode', component: PasscodeComponent },
  { path: '**', redirectTo: 'start'}

  
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{
    scrollPositionRestoration: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
